<div class="container single-view" id="manage-market-users">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a [routerLink]="['/markets', marketId]" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'MANAGE_MARKET_USERS.BTN_BACK_TO_MARKET' | translate }}</a>
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 class="section-title">{{ 'MANAGE_MARKET_USERS.TITLE' | translate }}</h1>
          <p class="section-subtitle mt-1 text-base">{{ 'MANAGE_MARKET_USERS.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>

      <hr role="presentation" class="w-full mb-2 mt-6 border-t">

      <div class="view-content-wr">
        <!-- main content -->
        <form [formGroup]="addUsersToMarketFormGroup">
          <div class="row">
            <div class="flex flex-col col-12 text-wr mb-1">
              <h2>{{ 'MANAGE_MARKET_USERS.SEARCH_USERS' | translate }}</h2>
            </div>

            <div class="field-wr flex flex-col col-12">
              <label class="block text-sm mb-4" for="users">{{ 'MANAGE_MARKET_USERS.SEARCH_BY_USERNAME' | translate }}</label>
              <app-custom-dropdown
                id="users"
                data-testid="users"
                [placeholder]="'MANAGE_MARKET_USERS.SELECT_USER_PLACEHOLDER' | translate"
                [fieldLabel]="'MANAGE_MARKET_USERS.SELECT_USER_PLACEHOLDER' | translate"
                [options]="usersList"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="true"
                [showSelectionChips]="false"
                [showClear]="true"
                [compactUi]="false"
                [searchMode]="'remote'"
                [pageSize]="usersRowsPerPageOption"
                [totalCount]="usersTotalRecords"
                [totalPages]="getUsersTotalPages()"
                formControlName="users"
                (onLazyLoad)="onLazyLoadUsers($event)">
              </app-custom-dropdown>
            </div>

            @if (getSelectedUsers().length > 0) {
            <div class="flex flex-col col-12 text-wr">
              <p class="label text-sm">
                {{ 'MANAGE_MARKET_USERS.SELECTED_USERS' | translate }}:
              </p>

              <div class="chips-wr">
                @for (user of getSelectedUsers(); track user.id) {
                <div class="chip-item">
                  <p-chip [removable]="true" (onRemove)="removeUser(user)">
                    {{ user.text }}
                  </p-chip>
                </div>
                }
              </div>
            </div>
            }
          </div>

          <div class="row">
            <div class="col-12 mt-6 mb-4 pt-8 border-t">
              <div class="flex items-center justify-end gap-3">
                <button id="btn-manage-users" type="button" class="btn primary-btn" [disabled]="addUsersToMarketFormGroup.invalid || isSaving" (click)="submitForm()">{{ 'MANAGE_MARKET_USERS.BTN_ADD_USERS' | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <!-- /main content -->
      </div>
    </div>
  </div>
</div>
